import {Box, Button, Card, CardContent, Grid2, IconButton, Stack, Tooltip, Typography} from "@mui/material";
import {AddCircle} from "@mui/icons-material";
import {LoadingButton} from "@mui/lab";
import {When} from "react-if";
import {NotifyUsersModal} from "../../../../../components/notify-users-modal";
import React, {useState} from "react";
import {UserTypes} from "../../../../../types";
import {reportStyles} from "../../../../../components/reports/styles";
import ClearIcon from '@mui/icons-material/Clear';
import palette from "../../../../../theme/palette";

interface AddressType {
    address : string,
    placeId : string
}
interface Props {
    address : AddressType;
    setNotifyDetailsModalOpen : (flag:boolean)=>void;
    notifyDetailsModalOpen : boolean;
    saveReports : (users:UserTypes.Model[],isNotify:boolean)=>void;
    isSaveReportLoading : boolean;
    isRiskReport ?: boolean;
    onClose ?: ()=>void;
}
const styles = {
    addUserContainer: {
        borderRadius: 1,
        border: '0.3px solid #ccc',
        overflow: 'auto',
        p: 1,
        width:'100%',
        marginBottom:'80px',
        minHeight:'150px'
    },
    addUserEachUserBox:{
        paddingY:0.5,
        paddingX:1,
        background:'#ecf2fa',
        width:'100%',
        boxSizing:'border-box',
        border:'1px solid #ccc',
        borderRadius:1,
        color: palette.darkBlue,
        display:'flex'
    }
}

export const NotifyUser : React.FC<Props> = ({
                                                 address,
                                                 setNotifyDetailsModalOpen,
                                                 notifyDetailsModalOpen,
                                                 isSaveReportLoading,
                                                 saveReports,
                                                 isRiskReport,
                                                 onClose
                                             })=>{
    const [selectedUsersToNotify, setSelectedUsersToNotify] = useState<UserTypes.Model[]>([]);
    const [isNotifyLoading, setIsNotifyLoading] = useState<boolean>(false);

    const notifyUser = (isNotify:boolean) =>{
        setIsNotifyLoading(isNotify);
        saveReports(selectedUsersToNotify,isNotify);
    }
    return (
        <Stack width={{md:'710px',xs:'350px'}} margin={'auto'}>
            <Card>
                <CardContent>
                    <Stack alignItems={'center'} paddingTop={5} paddingX={{md:8,xs:1}}>
                        <Stack alignItems={'center'} paddingX={{md:8,xs:1}}>
                            <Typography fontWeight={500} fontSize={20} marginBottom={5} textAlign={'center'}>
                                {address.address}
                            </Typography>
                            <Typography  fontWeight={500} fontSize={14} marginBottom={2} textAlign={'center'}>
                                Do you want to notify users of this report?
                            </Typography>
                        </Stack>
                        <Box sx={{...styles.addUserContainer}}>
                            <Button sx={{color : palette.darkBlue }} startIcon={<AddCircle />} onClick={()=>{setNotifyDetailsModalOpen(true)}}>
                                {selectedUsersToNotify.length?'Update':'Add'} Users
                            </Button>
                            <Grid2
                                container
                                sx={{ mb: 3, mt: 0.5 }}
                                spacing={1}
                            >
                                {selectedUsersToNotify.map((user,index) => (
                                    <Grid2 key={user?.id}>
                                        <Box sx={{...styles.addUserEachUserBox}}>
                                            <Typography>
                                                {user?.firstName} {user?.lastName}
                                            </Typography>
                                            <Tooltip title="Remove user">
                                                <IconButton
                                                    sx={{padding : 0, right : '-5px' }}
                                                    onClick={() => {
                                                        setSelectedUsersToNotify(selectedUsersToNotify.filter((t) => t.id !== user.id));
                                                    }}
                                                >
                                                    <ClearIcon/>
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    </Grid2>
                                ))}
                            </Grid2>
                        </Box>
                        <Grid2 container sx={{ justifyContent: 'center' }} spacing={1}>
                            <When condition={!isRiskReport}>
                                <Grid2>
                                    <LoadingButton
                                        disabled={false}
                                        variant='contained'
                                        sx={{...reportStyles.button }}
                                        color={'inherit'}
                                        loading={!isNotifyLoading && isSaveReportLoading}
                                        onClick={()=>{notifyUser(false)}}
                                    >
                                        Done
                                    </LoadingButton>
                                </Grid2>
                            </When>
                            <When condition={isRiskReport}>
                                <Grid2>
                                    <LoadingButton
                                        sx={{...reportStyles.button}}
                                        variant="outlined-alternate"
                                        color="inherit"
                                        onClick={()=>{onClose!()}}
                                        disabled={false}
                                        loading={false}
                                    >
                                        Close
                                    </LoadingButton>
                                </Grid2>
                            </When>
                            <Grid2>
                                <LoadingButton
                                    sx={{...reportStyles.button}}
                                    variant='alternate'
                                    color={'primary'}
                                    loading={isNotifyLoading && isSaveReportLoading}
                                    disabled={selectedUsersToNotify.length === 0}
                                    onClick={()=>{notifyUser(true)}}
                                >
                                    Notify
                                </LoadingButton>
                            </Grid2>
                        </Grid2>
                    </Stack>
                </CardContent>
            </Card>
            <When condition={notifyDetailsModalOpen}>
                <NotifyUsersModal
                    visible={notifyDetailsModalOpen}
                    onClose={()=>{setNotifyDetailsModalOpen(false)}}
                    selectedUsersToNotify = {selectedUsersToNotify}
                    setSelectedUsersToNotify = {setSelectedUsersToNotify}
                />
            </When>
        </Stack>
    )
}